module.exports = __webpack_public_path__ + "img/mountain.15c230f1.svg";